import type { Client, RequestContext } from "../client";
export type ParentEnvironmentResource = {
    Id: string;
    SpaceId: string;
    Name: string;
    Slug: string;
    SortOrder: number;
    Description?: string;
    UseGuidedFailure: boolean;
    AutomaticDeprovisioningRule: AutomaticDeprovisioningRule;
};
export type AutomaticDeprovisioningRule = {
    ExpiryDays: number;
    ExpiryHours: number;
};
export type CreateParentEnvironmentCommand = {
    spaceId: string;
    name: string;
    slug?: string;
    description?: string;
    useGuidedFailure?: boolean;
    AutomaticDeprovisioningRule?: AutomaticDeprovisioningRule;
};
export type CreateParentEnvironmentResponse = {
    Id: string;
};
export type GetParentEnvironmentRequest = {
    Id: string;
    SpaceId: string;
};
export type GetParentEnvironmentResponse = ParentEnvironmentResource;
export type ModifyParentEnvironmentCommand = {
    SpaceId: string;
    Id: string;
    Name: string;
    Slug?: string;
    Description?: string;
    SortOrder?: number;
    UseGuidedFailure?: boolean;
    AutomaticDeprovisioningRule?: AutomaticDeprovisioningRule;
};
export type ModifyParentEnvironmentResponse = ParentEnvironmentResource;
export type DeleteParentEnvironmentCommand = {
    Id: string;
    SpaceId: string;
};
export class ParentEnvironmentRepository {
    protected client: Client;
    constructor(client: Client, private readonly requestContext: RequestContext) {
        this.client = client;
    }
    async create(command: CreateParentEnvironmentCommand): Promise<CreateParentEnvironmentResponse> {
        return await this.client.create<CreateParentEnvironmentCommand, CreateParentEnvironmentResponse>(this.requestContext, `~/api/spaces/{spaceId}/parentEnvironments`, command, {
            name: command.name,
            spaceId: command.spaceId,
        });
    }
    async get(request: GetParentEnvironmentRequest): Promise<GetParentEnvironmentResponse> {
        return await this.client.get<GetParentEnvironmentResponse>(this.requestContext, `~/api/spaces/{spaceId}/parentEnvironments/{Id}`, request);
    }
    async modify(command: ModifyParentEnvironmentCommand): Promise<ModifyParentEnvironmentResponse> {
        const response = await this.client.update<ModifyParentEnvironmentCommand>(this.requestContext, `~/api/spaces/{SpaceId}/parentEnvironments/{Id}`, command, {
            Name: command.Name,
            SpaceId: command.SpaceId,
            Id: command.Id,
            Slug: command.Slug ?? undefined,
            Description: command.Description ?? undefined,
            SortOrder: command.SortOrder ?? -1,
            UseGuidedFailure: command.UseGuidedFailure,
        });
        return await this.get({ Id: response.Id, SpaceId: response.SpaceId });
    }
    async delete(command: DeleteParentEnvironmentCommand): Promise<void> {
        await this.client.delete(this.requestContext, `~/api/spaces/{SpaceId}/parentEnvironments/{Id}`, command, {
            Id: command.Id,
            SpaceId: command.SpaceId,
        });
    }
}
